var map = {
	"./BaseAuthenticationPopup.vue": "./src/global/BaseAuthenticationPopup.vue",
	"./BaseButton.vue": "./src/global/BaseButton.vue",
	"./BaseContactPopup.vue": "./src/global/BaseContactPopup.vue",
	"./BaseDiscussionList.vue": "./src/global/BaseDiscussionList.vue",
	"./BaseInput.vue": "./src/global/BaseInput.vue",
	"./BaseLoading.vue": "./src/global/BaseLoading.vue",
	"./BaseMessage.vue": "./src/global/BaseMessage.vue",
	"./BasePopup.vue": "./src/global/BasePopup.vue",
	"./BaseToggle.vue": "./src/global/BaseToggle.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/global sync [\\w-]+\\.vue$";